// extracted by mini-css-extract-plugin
export default {"container":"CurrentTime_container__R9Kmk","label":"CurrentTime_label__fAYyh","time":"CurrentTime_time__AR+CW"};